import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckToken from "../_Login/CheckToken";
import useInvoke from "../Tools/Invoker";
import EductorGetTests from "./EductorGetTests";
import EductorAddTest from "./EductorAddTest";
import toast from "react-hot-toast";

const EductorTests2 = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const { id } = useParams();

    //get eductor data
    let response76 = useInvoke("Eductor", "76", { "eductorID": id });

    //get users
    let response64 = useInvoke("WebApps", "64", {});

    const [eductor, setEductor] = useState({});
    const [users, setUsers] = useState([]);
    const [tests, setTests] = useState([]);

    useEffect(() => {
        document.title = "Eductor Tests";
    }, []);

    // get eductor details
    useEffect(() => {

        if (response76.data.payload != undefined) {
            let data = JSON.parse(response76.data.payload).data[0];

            let datecompleted = "";
            let bspr_datecompleted = "";

            const parts5 = data[5].split('/');
            const parts23 = data[23].split('/');

            if (parts5.length > 1) {
                datecompleted = new Date(parts5[2], parts5[0] - 1, parts5[1]).toISOString().split('T')[0];
            }

            if (parts23.length > 1) {
                bspr_datecompleted = new Date(parts23[2], parts23[0] - 1, parts23[1]).toISOString().split('T')[0];
            }

            //calculate air density
            let calculated_air_density = 0;
            let tempFahrenheit = parseFloat(data[39]);
            let humidityPercentage = parseFloat(data[40]);
            let pressureInchesMercury = parseFloat(data[41]);
            let tempCelsius = ((parseFloat(tempFahrenheit) - 32) / 1.8);
            let tempKelvin = (parseFloat(tempFahrenheit) + (459.67)) * (5 / 9);
            let pressurePascals = parseFloat(pressureInchesMercury) * 3386.39;
            let vaporPressure = (parseFloat(humidityPercentage) / 100) * (6.105 ^ (17.27 * parseFloat(tempCelsius) / (parseFloat(tempCelsius) + 237.7)))
            let dryPressure = parseFloat(pressurePascals) - parseFloat(vaporPressure);
            let airDensityKilogramsMeterCubed = (parseFloat(dryPressure) / (287.058 * parseFloat(tempKelvin)));
            let airDensityLbFootCubed = 0.062428 * parseFloat(airDensityKilogramsMeterCubed);
            calculated_air_density = parseFloat(airDensityLbFootCubed).toFixed(6);

            let obj = {
                "id": data[0],
                "jobnumber": data[1],
                "quotenumber": data[2],
                "model": data[3],
                "datecreated": data[4],
                "datecompleted": datecompleted,
                "testedbyid": data[6],
                "approvedbyid": data[7],
                "sketchnumber": data[8],
                "frequency": data[9],
                "inletdiameter": data[10],
                "outletdiameter": data[11],
                "horsepower": data[12],
                "velocity": data[13],
                "cspr_inducedairflow": data[14],
                "cspr_inletstaticpressure": data[15],
                "cspr_dischargestaticpressure": data[16],
                "bspr_manufacturermodel": data[17],
                "bspr_airflowcfm": data[18],
                "bspr_calculatedbhp": data[19],
                "bspr_inletstaticpressure": data[20],
                "bspr_outletstaticpressure": data[21],
                "bspr_purchaseordernumber": data[22],
                "bspr_datecompleted": bspr_datecompleted,
                "apr_plenumpressure": data[24],
                "apr_nozzlesetting": data[25],
                "apr_staticclosedoff": data[26],
                "apr_tight": data[27],
                "apr_motorrpm": data[28],
                "apr_motorvoltage": data[29],
                "apr_calculatedblowerairflow": data[30],
                "apr_plenumtype": data[31],
                "apr_motoramps1": data[32],
                "apr_motoramps2": data[33],
                "apr_motoramps3": data[34],
                "apr_motorampsaverage": data[35],
                "apr_motorampsrated": data[36],
                "notes": data[37],
                "customer": data[38],
                "air_temperature": parseFloat(data[39]),
                "air_humidity": parseFloat(data[40]),
                "air_pressure": parseFloat(data[41]),
                "intakesilencer": data[42] == "False" ? 0 : 1,
                "apr_motornotes": data[43],
                "suffix": data[44] || "",
                "air_density": calculated_air_density,
            };

            setEductor(obj);

        }

    }, [response76.data.payload]);

    //get user list
    useEffect(() => {

        if (response64.data.payload != undefined) {
            let data = JSON.parse(response64.data.payload).data;

            let userList = [];

            data.forEach((user, index) => {

                let obj = {
                    "id": user[0],
                    "firstname": user[1],
                    "lastname": user[2],
                    "email": user[3],
                    "mustchangepassword": user[4],
                    "role": user[5]
                };

                userList.push(obj);

            });

            setUsers(userList);

        }

    }, [response64.data.payload]);

    useEffect(() => {

        EductorGetTests(id)
            .then(response => {

                if (response.success) {

                    let data = JSON.parse(response.payload).data;

                    let testList = [];

                    data.forEach((test, index) => {

                        let sum = 0;
                        let avg = 0;
                        let count = 0;

                        let tests = [
                            Math.sqrt(parseFloat(test[8])),
                            Math.sqrt(parseFloat(test[9])),
                            Math.sqrt(parseFloat(test[10])),
                            Math.sqrt(parseFloat(test[11])),
                            Math.sqrt(parseFloat(test[12])),
                            Math.sqrt(parseFloat(test[13])),
                            Math.sqrt(parseFloat(test[14])),
                            Math.sqrt(parseFloat(test[15])),
                            Math.sqrt(parseFloat(test[16])),
                            Math.sqrt(parseFloat(test[17])),
                            Math.sqrt(parseFloat(test[18]))
                        ];

                        // Calculate the sum, count, and average of the tests
                        tests.forEach((test, index) => {
                            if (test != 0) {
                                sum += test;
                                count++;
                            }
                        });

                        avg = (count > 0 ? sum / count : 0);

                        //get the inner diameter
                        let innerDiameter = calcInnerDiameter(test[5], test[22]);

                        let obj = {
                            "row": index,
                            "id": test[0],
                            "eductorid": test[1],
                            "percentage": test[2],
                            "inletoutlet": test[3],
                            "blowerintake": test[4],
                            "diameter": parseFloat(test[5]) || 0,
                            //"area": test[6],
                            "area": calcArea(innerDiameter) || 0,
                            "staticpressure": parseFloat(test[7]) || 0,
                            "vp1": parseFloat(test[8]) || 0,
                            "vp2": parseFloat(test[9]) || 0,
                            "vp3": parseFloat(test[10]) || 0,
                            "vp4": parseFloat(test[11]) || 0,
                            "vp5": parseFloat(test[12]) || 0,
                            "vp6": parseFloat(test[13]) || 0,
                            "vp7": parseFloat(test[14]) || 0,
                            "vp8": parseFloat(test[15]) || 0,
                            "vp9": parseFloat(test[16]) || 0,
                            "vp10": parseFloat(test[17]) || 0,
                            "vp11": parseFloat(test[18]) || 0,
                            "average": parseFloat(avg),
                            "notes": test[19],
                            "datecreated": test[20],
                            "datemodified": test[21],
                            "gauge": test[22] || "",
                            "inner_diameter": innerDiameter,
                            "cfm": "",
                            "velocity": "",
                        };

                        obj["cfm"] = calcCFM(obj);
                        obj["velocity"] = calcVelocity(obj);

                        testList.push(obj);

                    });

                    setTests(testList);
                }
            });


    }, [eductor]);

    const calcInnerDiameter = (diameter, thickness) => {

        if (diameter == undefined || thickness == undefined) {
            return 0;
        }
        else if (thickness == "1/32") {
            return parseFloat(diameter) - (2 * (1 / 32));
        }
        else if (thickness == "1/16") {
            return parseFloat(diameter) - (2 * (1 / 16));
        }
        else if (thickness == "1/8") {
            return parseFloat(diameter) - (2 * (1 / 8));
        }
        else if (thickness == "3/16") {
            return parseFloat(diameter) - (2 * (3 / 16));
        }
        else if (thickness == "1/4") {
            return parseFloat(diameter) - (2 * (1 / 4));
        }
        else if (thickness == "1/2") {
            return parseFloat(diameter) - (2 * (1 / 2));
        }

    };

    const calcArea = (innerDiameter) => {

        return parseFloat((innerDiameter * 0.5) * (innerDiameter * 0.5) * Math.PI / 144);

    };

    // Requires vp values, eductor air density, and area
    const calcCFM = (test) => {

        if (!test || !eductor.air_density) return 0;

        let sum = 0;
        let count = 0;
        let avg = 0;

        for (let i = 1; i <= 11; i++) {
            const vp = parseFloat(test[`vp${i}`]);
            if (!isNaN(vp) && vp != 0) {
                sum += Math.sqrt(vp);
                count++;
            }
        }

        avg = (count > 0 ? sum / count : 0);

        let airDensityFactor = Math.sqrt(parseFloat(eductor["air_density"]));
        let velocity = (parseFloat(avg) / airDensityFactor) * 1096;
        let area = parseFloat(test["area"]);
        let cfm = (parseFloat(velocity) * parseFloat(area));

        return cfm;

    }

    // Requires vp values and eductor air density
    const calcVelocity = (test) => {

        if (!test || !eductor.air_density) return 0;

        let vps = [];
        for (let i = 1; i <= 11; i++) {
            const vp = parseFloat(test[`vp${i}`]);
            if (!isNaN(vp) && vp != 0) vps.push(Math.sqrt(vp));
        }

        if (vps.length == 0) return 0;

        const avg = vps.reduce((a, b) => a + b, 0) / vps.length;
        const airDensityFactor = Math.sqrt(parseFloat(eductor.air_density));
        const velocity = (avg / airDensityFactor) * 1096;

        return parseFloat(velocity);

    }

    const calcAvgSQRTVP = (test) => {

        if (!test) return 0;

        let sum = 0;
        let count = 0;

        for (let i = 1; i <= 11; i++) {
            const vp = parseFloat(test[`vp${i}`]);
            if (!isNaN(vp) && vp != 0) {
                sum += Math.sqrt(vp);
                count++;
            }
        }

        return (count > 0 ? sum / count : 0);
    }

    const handleUpdateTest = (index, field, value) => {

        let newTests = [...tests];

        if (field == "diameter") {
            let newInnerDiameter = calcInnerDiameter(value, tests[index]["gauge"]);
            let newArea = calcArea(newInnerDiameter);

            newTests[index] = {
                ...newTests[index],
                ["diameter"]: value,
                "inner_diameter": newInnerDiameter,
                "area": newArea
            };
        }

        else if (field == "gauge") {
            let newInnerDiameter = calcInnerDiameter(tests[index]["diameter"], value);
            let newArea = calcArea(newInnerDiameter);

            newTests[index] = {
                ...newTests[index],
                ["gauge"]: value,
                "inner_diameter": newInnerDiameter,
                "area": newArea
            };
        }

        else {
            newTests[index] = {
                ...newTests[index],
                [field]: value
            };
        }

        //  Always recalculate 
        newTests[index] = {
            ...newTests[index],
            "cfm": calcCFM(newTests[index]),
            "velocity": calcVelocity(newTests[index]),
            "average": calcAvgSQRTVP(newTests[index])
        };

        setTests(newTests);
    };

    const handleSaveChanges = () => {

        let testList = tests;

        testList.forEach((test, index) => {

            EductorAddTest(
                test["id"],
                test["eductorid"],
                test["percentage"],
                test["inletoutlet"],
                test["blowerintake"],
                test["diameter"] || 0,
                test["area"] || 0,
                test["staticpressure"] || 0,
                test["vp1"] || 0,
                test["vp2"] || 0,
                test["vp3"] || 0,
                test["vp4"] || 0,
                test["vp5"] || 0,
                test["vp6"] || 0,
                test["vp7"] || 0,
                test["vp8"] || 0,
                test["vp9"] || 0,
                test["vp10"] || 0,
                test["vp11"] || 0,
                test["notes"],
                test["gauge"]
            ).then((response) => {
                if (response.success && index == testList.length - 1) {
                    toast.success("Tests saved successfully.");
                }
            });
        });

    };

    return (
        <>

            <div style={{ display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between", width: "1100px" }}>
                <Link to={`/Eductor/Details/${id}`} className="btn btn-default" style={{ margin: "8px 0px", width: "auto" }}>Discard Changes and Return to Eductor</Link>
                <button className="btn btn-success" style={{ margin: "8px 0px", width: "auto" }} onClick={handleSaveChanges}>Save Changes</button>
            </div>

            <div className="card" style={{ margin: "auto", width: "1100px" }}>

                <div className="card-title" style={{ fontWeight: "bold", color: "var(--bs-primary)", fontSize: "24px", marginLeft: "16px", marginTop: "8px" }}>Eductor Performance Tests: {eductor["model"]}</div>

                <div className="card-body">

                    {/* Air Properties */}
                    <div className="card border-secondary mb-3" style={{ margin: "8px", backgroundColor: "var(--bs-white)" }}>
                        <div className="card-title" style={{ color: "var(--bs-primary)", margin: "4px" }}>
                            <span style={{ fontWeight: "bold", fontSize: "18px", color: "var(--bs-dark)", marginLeft: "8px" }}>
                                <b>Air Properties During Test</b>
                            </span>
                        </div>

                        <div className="card-body" style={{ padding: "4px", backgroundColor: "var(--bs-white)" }}>
                            <table className="" style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: "center", padding: "4px" }}>
                                            <span style={{ textDecoration: "underline" }}>Temperature</span>:&nbsp;<span>{eductor["air_temperature"]}°F</span>
                                        </td>
                                        <td style={{ textAlign: "center", padding: "4px" }}>
                                            <span style={{ textDecoration: "underline" }}>Humidity</span>:&nbsp;<span>{eductor["air_humidity"]}%</span>
                                        </td>
                                        <td style={{ textAlign: "center", padding: "4px" }}>
                                            <span style={{ textDecoration: "underline" }}>Pressure</span>:&nbsp;<span>{eductor["air_pressure"]} inHg</span>
                                        </td>
                                        <td style={{ textAlign: "center", padding: "4px" }}>
                                            <span style={{ textDecoration: "underline" }}>Density</span>:&nbsp;<span>{eductor["air_density"]} lb/ft³</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    {tests.length > 0
                        ? (
                            <>
                                {tests.map((t, index) => (
                                    <div key={index} className="card border-secondary mb-3" style={{ margin: "8px", backgroundColor: t["inletoutlet"] === "False" ? "var(--bs-white)" : "var(--bs-gray-200)" }}>

                                        <div className="card-title" style={{ color: "var(--bs-primary)", margin: "4px" }}>
                                            <span style={{ fontWeight: "bold", fontSize: "18px", color: "var(--bs-dark)", marginLeft: "8px", textDecoration: "underline" }}>
                                                <b>{t["inletoutlet"] === "False" ? "Inlet" : "Outlet"}</b>
                                            </span>
                                            -
                                            <span style={{ fontWeight: "bold", fontSize: "18px", color: "var(--bs-dark)", marginLeft: "4px" }}>{t["percentage"]} % Open</span>

                                        </div>

                                        <div className="card-body" style={{ padding: "4px", backgroundColor: t["inletoutlet"] === "False" ? "var(--bs-white)" : "var(--bs-gray-200)" }}>

                                            {/* Details */}
                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "center", margin: "4px", minWidth: "108px" }}>

                                                    {/* Diameter */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>Diameter</span>
                                                        <input type="number" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            onChange={(e) => handleUpdateTest(index, "diameter", e.target.value)}
                                                            value={t["diameter"]}
                                                        />
                                                    </div>

                                                    {/* Gauge */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "128px" }}>
                                                        <span>Gauge</span>
                                                        <select className="form-select" style={{ width: "auto", fontSize: "14px", height: "100%", marginLeft: "4px" }}
                                                            onChange={(e) => handleUpdateTest(index, "gauge", e.target.value)}
                                                            value={t["gauge"] || ""}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1/2">0 ga (1/2")</option>
                                                            <option value="1/4">3 ga (1/4")</option>
                                                            <option value="3/16">7 ga (3/16")</option>
                                                            <option value="1/8">11 ga (1/8")</option>
                                                            <option value="1/16">16 ga (1/16")</option>
                                                            <option value="1/32">22 ga (1/32")</option>
                                                        </select>
                                                    </div>

                                                    {/* Inner Diameter */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>Inner Diameter</span>
                                                        <input type="number" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={t["inner_diameter"]}
                                                            disabled
                                                        />
                                                    </div>

                                                    {/* Area */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>Area</span>
                                                        <input type="text" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={parseFloat(t["area"]).toFixed(3)}
                                                            disabled
                                                        />
                                                    </div>

                                                    {/* SP */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>SP</span>
                                                        <input type="text" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={t["staticpressure"]}
                                                            onChange={(e) => handleUpdateTest(index, "staticpressure", e.target.value)}
                                                        />
                                                    </div>

                                                    {/* Avg√VP */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>Avg√VP</span>
                                                        <input type="text" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={parseFloat(t["average"]).toFixed(3)}
                                                            disabled
                                                        />
                                                    </div>

                                                    {/* CFM */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>CFM</span>
                                                        <input type="text" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={parseFloat(t["cfm"]).toFixed(0)}
                                                            disabled
                                                        />
                                                    </div>

                                                    {/* Velocity */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px", minWidth: "108px" }}>
                                                        <span>Velocity</span>
                                                        <input type="text" autoComplete="off" className="form-control" style={{ width: "auto", fontWeight: "bold" }}
                                                            value={parseFloat(t["velocity"]).toFixed(0)}
                                                            disabled
                                                        />
                                                    </div>

                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "center", margin: "4px", minWidth: "108px" }}>

                                                    {/* VP 1-11 */}
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                                        {/* Loop through all VP's 1-11 */}
                                                        {[...Array(11)].map((_, i) => (
                                                            <div key={i} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", margin: "4px" }}>
                                                                <span>{`VP ${i + 1}`}</span>
                                                                <input autoComplete="off" id={`${index}_vp${i + 1}`} type="number" className="form-control" style={{ width: "100%" }}
                                                                    step="0.1"
                                                                    value={t[`vp${i + 1}`]}
                                                                    onChange={(e) => handleUpdateTest(index, `vp${i + 1}`, e.target.value)}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>

                                                {/* Notes */}
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignContent: "center", width: "98%", margin: "1%" }}>

                                                    <span>Notes</span>
                                                    <textarea cols="140" className="form-control" style={{ maxWidth: "100%" }}
                                                        value={t["notes"]}
                                                        onChange={(e) => handleUpdateTest(index, "notes", e.target.value)}
                                                    />

                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                ))}
                            </>

                        )
                        : (
                            <>
                                <div className="alert alert-info" role="alert" style={{ margin: "8px" }}>
                                    <strong>An error has occurred while fetching tests.</strong>
                                </div>
                            </>
                        )

                    }

                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between", width: "1100px" }}>
                <Link to={`/Eductor/Details/${id}`} className="btn btn-default" style={{ margin: "8px 0px", width: "auto" }}>Discard Changes and Return to Eductor</Link>
                <button className="btn btn-success" style={{ margin: "8px 0px", width: "auto" }} onClick={handleSaveChanges}>Save Changes</button>
            </div>

        </>
    );
}

export default EductorTests2;